<template>
  <nav class="top-0 fixed w-full z-20">
    <div v-bind:class="{ darkNav: !whiteNavTheme, whiteNav: whiteNavTheme }">
      <span
        class="
          lg:max-w-screen-xl
          m-auto
          flex
          items-center
          justify-between
          flex-wrap
          py-6
          px-5
          max-w-2xl
        "
      >
        <div class="flex items-center flex-shrink-0 lg:mr-6">
          <router-link
            to="/"
            id="logo"
            class="font-serif border-none text-2xl tracking-wide"
            >Haus Morgensonne</router-link
          >
          <!-- <span class="font-bold">
            <a
              href="/"
              class="font-serif text-2xl tracking-wide font-normal"
              >Haus Morgensonne</a
            >
          </span> -->
        </div>
        <div class="block lg:hidden">
          <button
            class="flex items-center px-3 py-2 border border-solid rounded-sm"
            @click="collapsed = !collapsed"
          >
            <svg
              class="fill-current h-3 w-3"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Menü</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
          </button>
        </div>
        <div
          :class="
            collapsed
              ? 'w-full hidden lg:flex duration-150 ease-in-out flex-grow lg:items-center lg:w-auto'
              : 'w-full flex-grow lg:flex lg:items-center lg:w-auto'
          "
        >
          <ul
            class="
              items-end
              -mt-2
              text-sm
              py-4
              lg:py-0 lg:mr-12 lg:flex-grow lg:flex lg:justify-end
              uppercase
            "
            @click="collapsed = !collapsed"
          >
            <li>
              <router-link to="/">Start</router-link>
            </li>
            <li>
              <router-link to="/haus">Wohnhaus</router-link>
            </li>
            <li>
              <router-link to="/ferienwohnung">Ferienwohnung</router-link>
            </li>
            <li>
              <router-link to="/ueber-uns">Über uns</router-link>
            </li>
            <li>
              <router-link to="/die-region">Die Region</router-link>
            </li>
            <li>
              <router-link to="/kontakt">Kontakt</router-link>
            </li>
          </ul>
        </div>
      </span>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavbarDesktop',
  computed: {
    whiteNavTheme() {
      return this.$store.state.whiteNavTheme
    },
  },
  data() {
    return {
      collapsed: true,
    }
  },
}
</script>
<style scoped>
#logo {
  @apply font-normal;
}
.whiteNav {
  @apply text-white;
}
.whiteNav li {
  @apply block mt-4 text-gray-300 font-bold transition-colors duration-300 ease-in-out;
}
.whiteNav a.router-link-exact-active {
  @apply text-white py-1 font-bold border-b border-gray-200  transition-colors duration-200 ease-in-out;
}
.whiteNav li:hover {
  @apply text-white;
  @apply transition-colors;
  @apply duration-300;
}
.whiteNav li:focus {
  @apply text-blue-700;
}

.darkNav {
  @apply text-gray-800 bg-gray-100;
}
.darkNav li {
  @apply block mt-3 text-gray-600 font-bold transition-colors duration-300 ease-in-out;
}
.darkNav a.router-link-exact-active {
  @apply text-gray-900 py-1 border-b border-red-500 font-bold transition-colors duration-200 ease-in-out;
}
.darkNav li:hover {
  @apply text-gray-800;
  @apply transition-colors;
  @apply duration-300;
}
.darkNav li:focus {
  @apply text-blue-700;
}

@screen lg {
  li {
    @apply inline-block mt-0 pl-12;
  }
}
</style>
